import { getColor } from '../../../../theme-tools';
export function getDefaults(_ref) {
  var {
    focusBorderColor = 'grey.800',
    errorBorderColor = 'red.800',
    focusBoxShadowColor = 'yellow.200',
    errorBoxShadowColor = focusBoxShadowColor
  } = _ref;
  return {
    focusBorderColor,
    errorBorderColor,
    focusBoxShadowColor,
    errorBoxShadowColor
  };
}
var getContainerStyles = () => {
  return {
    borderRadius: 0,
    width: '100%',
    display: 'flex',
    position: 'relative',
    transition: 'all 0.2s'
  };
};
var getVariantOutline = props => {
  var {
    theme
  } = props;
  var {
    focusBorderColor,
    errorBorderColor,
    focusBoxShadowColor,
    errorBoxShadowColor
  } = getDefaults(props);
  return {
    field: {
      borderColor: '#666666',
      borderRadius: 'none',
      _placeholder: {
        color: '#666666'
      },
      _disabled: {
        bg: 'white',
        borderWidth: '3px',
        borderColor: 'grey.500',
        color: 'grey.800'
      },
      _focus: {
        borderColor: focusBorderColor,
        boxShadow: "0 0 0 3px ".concat(getColor(theme, focusBoxShadowColor))
      },
      _invalid: {
        borderColor: errorBorderColor,
        borderWidth: '2px',
        boxShadow: 'none',
        _focus: {
          boxShadow: "0 0 0 3px ".concat(getColor(theme, errorBoxShadowColor))
        }
      }
    },
    addon: {
      border: 'none',
      borderRadius: 'none',
      bg: 'grey.100'
    }
  };
};
var baseStyle = () => ({
  container: getContainerStyles(),
  field: {
    borderColor: '#666666',
    borderRadius: 'none'
  }
});
export var Input = {
  baseStyle,
  variants: {
    outline: getVariantOutline
  }
};